export const ReportTypes = {
  Pdf: 1,
  Csv: 2
};
